import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { AuthUserFacadeService } from '../services/auth-user-facade.service';
import { NavigationWebService } from '../services/navigation.service';

export const AuthGuard: CanActivateFn = (actRoute: ActivatedRouteSnapshot) => {
  const authService = inject(AuthUserFacadeService);
  const navService = inject(NavigationWebService);
  const user = authService.getAuthProfile();
  const router = inject(Router);

  if (Object.keys(user || {}).length !== 0) {
    // authorised so return true
    return true;
  }
  // not logged in so redirect to login page with the return url
  // TODO - temp pass query params, need to handle better later of admin pin reset
  return router.createUrlTree(navService.getLoginSegments(), {
    queryParams: actRoute.queryParams,
  });
};
